import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  input,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'lib-option-open-end',
  standalone: true,
  imports: [],
  templateUrl: './option-open-end.component.html',
  styleUrl: './option-open-end.component.css',
})
export class OptionOpenEndComponent implements AfterViewInit {
  @Input({ required: true }) name!: string;
  @Input({ required: true }) optionKey!: number;
  @Input() placeholder: string = '';
  isSelected = input.required<boolean>();

  @Output() inputChange = new EventEmitter<string>();

  @ViewChild('inputEl') inputEl!: ElementRef<HTMLInputElement>;

  ngAfterViewInit() {
    // Focus instantly when the slotUnder content is rendered
    setTimeout(() => this.inputEl.nativeElement.focus(), 0);
  }

  onInputChange(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    this.inputChange.emit(val);
  }
}
